import { JSONModel, toJSONContext } from '../../models/jsonModel';
import Image, { ImageJSON } from '@/store/models/image';

export enum ClinicalTrainingEventStatus {
  Inactive = 0,
  Active = 1,
}

export interface ClinicalTrainingEventJSON {
  id: number;
  name: string;
  event_url: string;
  image?: ImageJSON | ImageJSON[];
  products: number[];
  users: number[];
  status: ClinicalTrainingEventStatus;
  start_date: string;
  end_date: string;
  notes?: string;
  participant_count: number;
  is_full: boolean;
  is_user_subscribed: boolean;
  created_at: string;
  updated_at: string;
}

export interface ClinicalTrainingEventModal {
  id: number;
  name: string;
  eventUrl: string;
  image: string;
  startDate: string;
  endDate: string;
  notes: string;
  participantCount: number;
  isFull: boolean;
  isUserSubscribed: boolean;
}

export default class ClinicalTrainingEvent extends JSONModel<ClinicalTrainingEventJSON> {
  id: number = 0;
  name: string = '';
  eventUrl: string = '';
  image?: Image;
  products: number[] = [];
  users: number[] = [];
  status: ClinicalTrainingEventStatus = ClinicalTrainingEventStatus.Active;
  startDate: string = '';
  endDate: string = '';
  notes: string = '';
  participantCount: number = 0;
  isFull: boolean = false;
  isUserSubscribed: boolean = false;
  created_at: string = '';
  updated_at: string = '';

  public fromJSON(json: ClinicalTrainingEventJSON): void {
    this.id = Number(json.id);
    this.name = String(json.name || '');
    this.eventUrl = String(json.event_url || '');

    this.products = Array.isArray(json.products) ? json.products : [];
    this.users = Array.isArray(json.users) ? json.users : [];
    this.status = Number(json.status) === 0 ? ClinicalTrainingEventStatus.Inactive : ClinicalTrainingEventStatus.Active;
    
    if (json.image) {
      const image = Array.isArray(json.image) ? json.image[0] : json.image;

      if (image) {
        this.image = Image.fromJSON(image);
      }
    }
    
    // Store full datetime strings for datetime-local input
    this.startDate = String(json.start_date || '');
    this.endDate = String(json.end_date || '');
    
    this.notes = String(json.notes || '');
    this.participantCount = Number(json.participant_count || 0);
    this.isFull = Boolean(json.is_full || false);
    this.isUserSubscribed = Boolean(json.is_user_subscribed || false);
    this.created_at = String(json.created_at || '');
    this.updated_at = String(json.updated_at || '');
  }

  public toJSON(context: toJSONContext = 'server'): ClinicalTrainingEventJSON {
    return {
      id: this.id,
      name: this.name,
      event_url: this.eventUrl,
      image: this.image ? (this.image instanceof Image ? this.image.toJSON(context) : this.image) : undefined,
      products: this.products,
      users: this.users,
      status: this.status,
      start_date: this.startDate || '',
      end_date: this.endDate || '',
      notes: this.notes,
      participant_count: this.participantCount,
      is_full: this.isFull,
      is_user_subscribed: this.isUserSubscribed,
      created_at: this.created_at,
      updated_at: this.updated_at,
    };
  }
}
